import { GetterTree } from 'vuex';
import { RootState } from '@/store/store';
import { EEditorContentGetter } from '@/editor/editor-block/store/editor-content.constants';
import { IEditorContentState } from '@/editor/editor-block/store/editor-content.types';
import { ICell, IEditorBlock, IField, IRow, ISection, ITable, IText } from '@/editor/types';
import { EFieldType } from '@/editor/types/enums';

const getFields = (blocks: IEditorBlock[]): IField[] => {
  return blocks
    .flatMap(({ content }: IEditorBlock) => content.sections)
    .flatMap(({ rows }: ISection) => rows)
    .flatMap(({ cells }: IRow) => cells)
    .flatMap(({ nodes }: ICell) => nodes)
    .filter((node: IText | ITable) => !!node.fields)
    .flatMap(({ fields }: IText | ITable) => fields);
};

export const getters: GetterTree<IEditorContentState, RootState> = {
  [EEditorContentGetter.AllEditorFields]({ blocks }: IEditorContentState): IField[] {
    return getFields(blocks);
  },

  [EEditorContentGetter.AllUniqueCustomTags]({ blocks }: IEditorContentState): IField[] {
    const allCustomMergeTags = getFields(blocks).filter(({ type }) => type === EFieldType.Custom);
    const allCustomNames: string[] = allCustomMergeTags.map(({ customName }) => customName);
    const uniqueCustomNames = Array.from(new Set(allCustomNames));

    return uniqueCustomNames.map(name =>
      allCustomMergeTags.find(({ customName }) => customName === name)
    );
  },

  [EEditorContentGetter.BlockById]({
    blocks,
  }: IEditorContentState): (pageId: string) => IEditorBlock {
    return (id: string) => blocks.find(({ contentId }: IEditorBlock) => contentId === id);
  },
};
